module.exports = __webpack_public_path__ + "img/full2-min.c6041656.png";